module.exports = __webpack_public_path__ + "img/signal5.f5f144f9.svg";